/**
 * КАТО, для которых блоки показывают моки из hardData/*.json (демо-режим,
 * областной уровень). Для остальных КАТО — данные из бэка.
 *
 * `HARD_DATA_KATO` — канонический демо-КАТО (Акмолинская область, код 11),
 * на нём собраны моки.
 * `HARD_DATA_KATOS` — весь список демо-областей: регионы, где данных в
 * БД ещё нет, показывают ту же демо-витрину вместо пустых виджетов.
 * Абайская область (100000000) исключена — работает на данных с бэка.
 * Территория не выбрана (`null`) — тоже демо-режим.
 */
export const HARD_DATA_KATO = 110000000;

export const HARD_DATA_KATOS: readonly number[] = [
  110000000, 230000000, 350000000, 390000000, 430000000, 470000000,
  550000000, 610000000, 620000000,
];

/** Демо-режим: моки hardData вместо запросов к бэку. */
export const isHardDataKato = (kato: number | null | undefined): boolean =>
  kato == null || HARD_DATA_KATOS.includes(kato);

/**
 * Демо-режим раздела «Проекты» (US-05): эндпоинтов `/public/projects/*`
 * на бэке ещё нет, поэтому моки показываются на ЛЮБОМ областном КАТО
 * (XX0000000, включая пилотный ЗКО), а не только на демо-областях —
 * иначе на пилоте раздел всегда пуст. Районы и ниже — честный запрос →
 * «нет данных». Убрать вместе с появлением эндпоинтов.
 */
export const isProjectsDemoKato = (kato: number | null | undefined): boolean =>
  isHardDataKato(kato) || (kato != null && kato % 10_000_000 === 0);
